var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8861 5.74805C15.946 5.74807 15.9883 5.76403 16.0385 5.81445C16.0889 5.8651 16.1058 5.90863 16.1058 5.9707C16.1058 6.03239 16.089 6.07629 16.0394 6.12695L8.02478 14.1367C7.97118 14.1899 7.9286 14.2041 7.87439 14.2041C7.8202 14.2041 7.77799 14.1907 7.72595 14.1387L3.9447 10.3564C3.8982 10.3083 3.88464 10.2687 3.88611 10.2119C3.88789 10.1454 3.90725 10.0968 3.96033 10.0439C4.01087 9.99365 4.05471 9.97762 4.11658 9.97754C4.17871 9.97754 4.22365 9.9935 4.27478 10.0439L7.52087 13.3057L7.87439 13.6611L8.22791 13.3066L15.7211 5.81934C15.777 5.76499 15.8246 5.74805 15.8861 5.74805Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhiteIcon);
export default __webpack_public_path__ + "static/media/checkWhiteIcon.79a07f43e79fa1397e4d7e4afb1c77f8.svg";
export { ForwardRef as ReactComponent };